import './styles.scss';
import { ReactComponent as Icon } from 'assets/icons/filter.svg';

const Filter = ({ children, onReset, hasSelected }) => {
    return (
        <div className="filter-sidebar">
            <div className="filter-sidebar__header">
                <Icon />
                Filter
            </div>
            <div className="filter-sidebar__body">{children}</div>
            {hasSelected && (
                <button className="filter-sidebar-reset" onClick={onReset}>
                    reset filter
                </button>
            )}
        </div>
    );
};

export default Filter;
